import _ from "lodash";
import React, { useEffect, useState } from "react";
import { Button, Segment, Table } from "semantic-ui-react";
import { DATA_TYPE_SCALAR, LimitData, Measurement, MeasurementData } from "../../models/testing_model";

export function ScalarOrArrayDataComponent(props: {
    measurement: Measurement,
    data: MeasurementData[]
}) {

    const { data: allData, measurement } = props;

    const [data, setData] = useState<MeasurementData[]>(allData);
    const channels = _.uniq(allData.map(d => d.channel)).sort();
    const previousIndexes = _.uniq(allData.map(d => d.index)).sort();

    const currentAttempts = useState(_.max(previousIndexes));

    useEffect(() => {
        setData(allData.filter(d => d.index === currentAttempts[0]));
    }, [allData, currentAttempts[0]])

    if (measurement.data_type == DATA_TYPE_SCALAR) {
        return <>
            {previousIndexes.length > 1 && <>
                <Button.Group size="mini" compact>
                    {previousIndexes.map(i => <Button key={i} size="mini" basic={currentAttempts[0] !== i} onClick={e => currentAttempts[1](i)}>Attempts {i}</Button>)}
                </Button.Group>
            </>}
            <Table selectable size="small" celled collapsing>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>Channel</Table.HeaderCell>
                        <Table.HeaderCell>Lower{measurement.limit_unit ? ` (${measurement.limit_unit})` : ''}</Table.HeaderCell>
                        <Table.HeaderCell>Value{measurement.result_unit ? ` (${measurement.result_unit})` : ''}</Table.HeaderCell>
                        <Table.HeaderCell>Upper{measurement.limit_unit ? ` (${measurement.limit_unit})` : ''}</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {channels.map((channel, index) => {
                        const channelData = data.find(d => d.channel == channel)!;
                        const value = channelData.result as number;
                        const limits = channelData.limits as LimitData<number>;

                        let lowerStatus = ''
                        let upperStatus = ''
                        let valueStatus = 'positive';
                        if (!value || !_.isNumber(value)) {
                            valueStatus = 'error';
                        }
                        
                        if (limits.lower && value < limits.lower) {
                            valueStatus = 'error';
                            lowerStatus = 'error'
                        }
                        
                        if (limits.upper && value > limits.upper) {
                            valueStatus = 'error';
                            upperStatus = 'error'
                        }

                        return <Table.Row key={channel}>
                            <Table.Cell>{channel}</Table.Cell>
                            <Table.Cell className={lowerStatus}>{!_.isNil(limits.lower) ? limits.lower : ''}</Table.Cell>
                            <Table.Cell className={valueStatus}>{value}</Table.Cell>
                            <Table.Cell className={upperStatus}>{!_.isNil(limits.upper) ? limits.upper : ''}</Table.Cell>
                        </Table.Row>
                    })}
                </Table.Body>
            </Table>
        </>
    }


    return <>
        {previousIndexes.length > 1 && <>
            <Button.Group size="mini" compact>
                {previousIndexes.map(i => <Button key={i} size="mini" basic={currentAttempts[0] !== i} onClick={e => currentAttempts[1](i)}>Attempts {i}</Button>)}
            </Button.Group>
        </>}
        <Segment.Group horizontal>
            {channels.map((channel, index) => {
                const channelData = data.find(d => d.channel == channel)!;
                const values = channelData.result as number[];
                const limits = channelData.limits as LimitData<number[]>;
                const gpibChannelNames = (JSON.parse(channelData.gpib_channel_names || '[]') as string[]).map(n => {
                    const ns = n.split('#');
                    if (ns[1].toLowerCase() !== 'none') {
                        return ns[1];
                    } else {
                        return `Port ${ns[0]}`;
                    }
                });

                return <Segment key={channel}><Table selectable size="small" celled collapsing>
                    <caption style={{ paddingBottom: '1rem' }}><h3>Channel{channel}</h3></caption>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell>Position</Table.HeaderCell>
                            <Table.HeaderCell>Lower{measurement.limit_unit ? ` (${measurement.limit_unit})` : ''}</Table.HeaderCell>
                            <Table.HeaderCell>Value{measurement.result_unit ? ` (${measurement.result_unit})` : ''}</Table.HeaderCell>
                            <Table.HeaderCell>Upper{measurement.limit_unit ? ` (${measurement.limit_unit})` : ''}</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {values.map((v, i) => {
                            const l = limits.lower ? limits.lower[i] : NaN;
                            const u = limits.upper ? limits.upper[i] : NaN;
                            let lowerStatus = ''
                            let upperStatus = ''
                            let valueStatus = 'positive';
                            if (!v || !_.isNumber(v)) {
                                valueStatus = 'error';
                            }  
                            
                            if (v < l) {
                                valueStatus = 'error';
                                lowerStatus = 'error'
                            } 
                            
                            if (v > u) {
                                valueStatus = 'error';
                                upperStatus = 'error'
                            }

                            return <Table.Row key={i}>
                                <Table.Cell>{gpibChannelNames[i] ? gpibChannelNames[i] : (i + 1)}</Table.Cell>
                                <Table.Cell className={lowerStatus}>{!_.isNil(l) ? l : ''}</Table.Cell>
                                <Table.Cell className={valueStatus}>{v || ''}</Table.Cell>
                                <Table.Cell className={upperStatus}>{!_.isNil(u) ? u : ''}</Table.Cell>
                            </Table.Row>
                        })}

                    </Table.Body>
                </Table></Segment>
            })}
        </Segment.Group>
    </>
}